<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .salary-section {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(15px);
  }

  .section-title {
    @include mixins.body2-bold();
  }

  .section-inputs {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(10px);

    .row {
      display: flex;
      width: 100%;
      justify-content: space-between;

      .row-item {
        flex: 1 1 calc(50% - utils.in_rem(13px));
        max-width: calc(50% - utils.in_rem(13px));

        .range-input {
          display: flex;
          flex-direction: row;
          gap: utils.in_rem(16px);
          align-items: center;
        }
      }
    }
  }
</style>

<script>
  import TextInput from "@sourcewhale/shared/svelte-design-system/components/molecules/InputFields/TextInput.svelte";
  import { editContactStore } from "../../../stores";
</script>

<div class="salary-section">
  <div class="section-title">Expected Salary</div>
  <div class="section-inputs">
    <div class="row">
      <div class="row-item">
        <div class="range-input">
          <div class="input">
            <TextInput
              label="Min base salary"
              bind:value={$editContactStore[`expectedSalaryMin`]}
            />
          </div>
          <div class="input">
            <TextInput
              label="Max base salary"
              bind:value={$editContactStore[`expectedSalaryMax`]}
            />
          </div>
        </div>
      </div>
      <div class="row-item">
        <div class="range-input">
          <div class="input">
            <TextInput
              label="Min bonus"
              bind:value={$editContactStore[`expectedBonusMin`]}
            />
          </div>
          <div class="input">
            <TextInput
              label="Max bonus"
              bind:value={$editContactStore[`expectedBonusMax`]}
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
